import { isValidObject } from "../../Services/validators";
// import { getLocationList } from "./Complaints";
import { alignPhoneNumber, dateAndTimeConverter } from "./Constants";

export const workforceTableHeadings = [
  { title: "SI.No", width: "50px", textAlign: "left" },
  { title: "EMPLOYEE ID", width: "200px", textAlign: "left" },
  { title: "NAME", width: "180px", textAlign: "left" },
  { title: "ROLE", width: "180px", textAlign: "left" },
  {
    title: "CONTACT",
    width: "180px",
    textAlign: "left",
    textTransform: "lowercase"
  },
  {
    title: "ATTENDANCE",
    width: "100px",
    textAlign: "right",
    textTransform: "uppercase"
  },
  { title: "LAST CAPTURED AT", width: "150px", textAlign: "left" },
  { title: "LAST CAPTURED IN", width: "180px", textAlign: "right" }
];

export const workforceQueryPath = {
  type: "type",
  assignedLocations: "connected.location"
};

export const defaultWorkforceFilter = {
  assignedLocations: [],
  role: [],
  dateRange: {
    type: "Today",
    from: new Date().toISOString().split("T")[0],
    to: new Date().toISOString().split("T")[0]
  },
  captureApproval: [],
  status: ["Active"]
};

export const getValidReportName = (key) => {
  switch (key) {
    case "face capture":
      return "captures";
    case "attendance log":
      return "attendance";
    case "employee profile":
      return "workforce";
    default:
      return key;
  }
};

export function workforceTableField(data) {
  switch (data) {
    case "SI.No":
      return "serialNo";
    case "EMPLOYEE ID":
      return "employeeId";
    case "NAME":
      return "name";
    case "ROLE":
      return "roles";
    case "CONTACT":
      return "phoneNumber";
    case "ATTENDANCE":
      return "attendance";
    case "LAST CAPTURED AT":
      return "capturedAt";
    case "LAST CAPTURED IN":
      return "capturedIn";
    default:
      return data?.toLowerCase();
  }
}

export const getRoleUsingId = (roles, id) => {
  return roles?.[id]?.name;
};

export function convertWorkforceToTableData(data, roles) {
  const workforceTableData = [];

  for (let i = 0; i < data.length; i++) {
    const item = data[i];
    const transformedItem = {
      ...item,
      serialNo: i + 1,
      documentId: item?.documentId,
      employeeId: item?.employeeId,
      name: item?.name,
      phoneNumber: item?.email || alignPhoneNumber(item?.phoneNumber),
      roles: item.roles
        ?.map((role) => getRoleUsingId(roles, role) || "N/A")
        .join(", "),
      attendance: item?.attendance,
      capturedAt: item?.captureStatus?.lastCapturedAt
        ? `${dateAndTimeConverter(
            item?.captureStatus?.lastCapturedAt,
            "Time"
          )}, ${dateAndTimeConverter(
            item?.captureStatus?.lastCapturedAt,
            "thirdDate"
          )}`
        : "N/A",
      capturedIn: item?.captureStatus?.location?.PCTNo
        ? `${item?.captureStatus?.location?.PCTNo} - ${item?.captureStatus?.location?.address}`
        : "N/A"
    };
    workforceTableData.push(transformedItem);
  }
  return workforceTableData;
}

export const workforceFilterData = (_locations, roles) => [
  {
    key: "dateRange",
    multiple: false,
    options: [
      "Lifetime",
      "Today",
      "Last 7 days",
      "Last 30 days",
      "Select Date"
    ],
    title: "DATE RANGE"
  },
  {
    key: "role",
    title: "ROLE",
    multiple: true,
    options: isValidObject(roles)
      ? Object.values(roles)
          .map((role) => role.name)
          .sort((a, b) => a.localeCompare(b))
      : []
  },
  // {
  //   key: "capturedLocations",
  //   title: "CAPTURED LOCATIONS",
  //   multiple: true,
  //   search: true,
  //   searchData: {
  //     label: "Search PCT / Address"
  //   },
  //   options: getLocationList(locations)
  // },
  {
    key: "captureApproval",
    title: "CAPTURE APPROVAL",
    multiple: false,
    options: ["PENDING"]
  },
  {
    key: "status",
    title: "STATUS",
    multiple: false,
    options: ["Active", "Archived"]
  }
];

export const capturesFilterData = {
  dateRange: {
    dataCy: "captures-date-range",
    key: "dateRange",
    multiple: false,
    options: ["Today", "Last 7 days", "Last 30 days", "Select Date"],
    title: "DATE RANGE"
  }
};

export const defaultCapturesFilter = {
  dateRange: {
    type: "Today",
    from: new Date().toISOString().split("T")[0],
    to: new Date().toISOString().split("T")[0]
  }
};
